$(function () {
    $(".faq-question").click(function() {
        let item = $(this).closest(".faq-item");

        // Zavrie ostatné (ak chceme accordion)
        $(".faq-item").not(item).removeClass("open").find(".faq-answer").stop(true, true).slideUp(200);

        // Prepne aktuálny
        item.toggleClass("open");
        item.find(".faq-answer").stop(true, true).slideToggle(200);
    });
});
